//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("installationScreening", InstallationScreeningFactory);

    InstallationScreeningFactory.$inject = ["apiClientFactory"];
    function InstallationScreeningFactory(apiClientFactory) {

        const routePrefix = "api/Installation/Screening/";

        return {
            Accept: apiClientFactory.patch(routePrefix + "Accept/"),
            DownloadExtract: apiClientFactory.getFile(routePrefix + "Extract/"),
            RegisterInspection: apiClientFactory.post(routePrefix + "RegisterInspection/"),
            Reject: apiClientFactory.patch(routePrefix + "Reject/"),
            Search: apiClientFactory.post(routePrefix + "Search/"),
        };
    }
})();
